module.exports = __webpack_public_path__ + "assets/img/gateway.8b77449c.svg";